import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div>
            <h3 className="footer-title">RealSoft Newsletter</h3>
            <p className="footer-text">
              Your weekly dose of tech insights, industry trends, and expert analysis to keep
              you ahead in the fast-paced world of technology.
            </p>
          </div>
          
          <div>
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/archive">Archive</Link></li>
              <li><Link to="/about">About Us</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="footer-title">Subscribe</h3>
            <p className="footer-text">
              Stay updated with our latest tech insights. Subscribe to our newsletter for weekly updates.
            </p>
            <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
              <Link to="/subscribe" className="read-more-button" style={{ width: '100%', display: 'block', boxSizing: 'border-box' }}>
                Subscribe Now
              </Link>
            </div>
          </div>
        </div>
        
        <div className="copyright">
          &copy; {new Date().getFullYear()} RealSoft Newsletter. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer; 